import { useState, useEffect } from "react";

export const useDirectoryConfig = () => {
	const [lat, setLat] = useState();
	const [lng, setLng] = useState();
	const [isLoading, setLoader] = useState(true);
	const [isRewards] = useState(false);
	const [isProd, setIsProd] = useState(undefined);


	useEffect(() => {
		getLocation();
		const isProd =
			window.location.origin === "https://invex-directory.reworth.app/" ||
			window.location.origin === "https://invex-directory.reworth.app"
				? true
				: false;
		setIsProd(isProd);
	}, []);

	const getLocation = () => {
		if (!navigator.geolocation) {
		} else {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					setLat(position.coords.latitude);
					setLng(position.coords.longitude);
					setLoader(false);
				},
				() => {
					console.log("Unable to retrieve your location");
					setLoader(false);
				}
			);
		}
	};

	return { lat, lng, isLoading, isRewards, isProd };
};
